module.exports = __webpack_public_path__ + "img/Boy_030021.57edf9fc.png";